import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import LockIcon from "@mui/icons-material/Lock";

const Forbidden403 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const message = location.state?.message || "شما به این صفحه دسترسی ندارید";

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "80vh",
          textAlign: "center",
        }}
      >
        <LockIcon sx={{ fontSize: 120, color: "error.main", mb: 3 }} />
        
        <Typography variant="h1" component="h1" gutterBottom sx={{ fontSize: "4rem", fontWeight: "bold" }}>
          403
        </Typography>
        
        <Typography variant="h5" gutterBottom color="text.secondary">
          دسترسی غیرمجاز
        </Typography>
        
        <Typography variant="body1" sx={{ mt: 2, mb: 4 }} color="text.secondary">
          {message}
        </Typography>
        
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => navigate("/", { replace: true })}
          >
            صفحه اصلی
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Forbidden403;
